/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderAuthOptions, FxIdApplicationPublicDataBuilderAuthOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderAuthOptionsToJSON, } from './FxIdApplicationPublicDataBuilderAuthOptions';
export function FxIdWebFeaturesPlayGameResponseAuthFromJSON(json) {
    return FxIdWebFeaturesPlayGameResponseAuthFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseAuthFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderAuthOptions(json)) {
        return FxIdApplicationPublicDataBuilderAuthOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesPlayGameResponseAuthToJSON(json) {
    return FxIdWebFeaturesPlayGameResponseAuthToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseAuthToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderAuthOptions(value)) {
        return FxIdApplicationPublicDataBuilderAuthOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesPlayGameResponseAuth.js.map